import { render, staticRenderFns } from "./ContentFeedList.vue?vue&type=template&id=198b55e2&scoped=true&"
import script from "./ContentFeedList.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedList.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedList.vue?vue&type=style&index=0&id=198b55e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b55e2",
  null
  
)

export default component.exports